import { get } from 'lodash'
import { createSelector } from 'reselect'
// tslint:disable-next-line: max-line-length
import IdentificationStep from '../components/organisms/background-check/usa/identification-step'
import * as Exp from '../experimentConstants'
import { validators as sharedValidators } from '../utilities/validators'

const getNeedsLicenseInfo = state => state.needsLicenseInfo

const getExperiments = state => state.experiments

export const getValidator = createSelector(
  getNeedsLicenseInfo,
  getExperiments,
  (needsLicenseInfo, experiments) => {
    let validator
    if (needsLicenseInfo) {
      if (get(experiments, `${Exp.BGC_UPDATE_FORM_VALIDATION}`, false)) {
        validator = Object.assign(IdentificationStep.checkrValidators, {})
      } else {
        validator = Object.assign(IdentificationStep.validators, {})
      }
    } else {
      validator = Object.assign(IdentificationStep.noLicenseValidators, {})
    }

    /**
     * If this experiment is on, add the confirmSsn
     * validator to enable the SSN confirmation field
     */
    if (get(experiments, `${Exp.BGC_UPDATE_FORM_VALIDATION}`, false)) {
      validator.confirmSsn = sharedValidators.confirmSsn
    }

    return validator
  }
)

export const getBGCFormExperiment = createSelector(
  getExperiments,
  experiments => get(experiments, `${Exp.BGC_UPDATE_FORM_VALIDATION}`, false)
)
